import kalpit from "../../../Images/KALPIT/kalpit.webp";
import React from "react";
import Navbar from "../../../Components/Common/Navbar.js";
import about_background from "../../../Images/Research/topbg.webp";
import "../../../Stylesheets/Publications.css";
import BackToTop from "../../../Components/Common/BackToTop.js";
import Footer from "../../Footer.js";
import Hero from "../../../Components/Common/Hero.js";
import { Link } from "react-router-dom";

import ReadMore from "../../../Components/Common/ReadMore.js";
import PublicationsFetch from "../../../Components/Publications/PublicationsFetchFunction.js";

function KALPIT() {
  return (
    <>
      <div className="min-vh-100">
        <BackToTop />
        <Navbar />
        <br />
        <br />
        <br />
        <Hero
          title="SERB-INAE KALPIT:"
          subTitle="Digital Creation to Enable Gamification Based on Indian Ethos"
          img={about_background}
          showAnimationText="false"
          creatorLink="https://unsplash.com/@pawel_czerwinski?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
          creator="Pawel Czerwinski"
          imageLink="https://unsplash.com/photos/an-abstract-pink-background-with-wavy-lines-bloGOumd0Z4?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
          source="Unsplash"
        />
        <br />
        <div className="container" style={{ paddingTop: "1em" }}>
          {/* <Breadcrumbs /> */}

          <div className="row">
            <div className="content-font-size" style={{ paddingBottom: "1em" }}>
              <ReadMore>
                In this work, we propose to create digital content for enabling
                games based on Indian ethos, culture, heritage, and values. The
                Indian heritage is one of the world's oldest civilizations, and
                its grandeur lies in its art, architecture, dance, music, flora
                and fauna, and philosophy of its people. However Indian heritage
                is losing its grandeur in the minds of the younger generation
                due to revolution in technology. The learning paradigm of Indian
                society is shifted from traditional textbook- based learning to
                technology-driven learning. Digital games are one of the such
                proven techniques for reinforcing our commitment for social
                diversity and community inclusion adopted across all age groups.
                Need is to build an ecosystem for content creation towards
                digital gaming based on Indian Ethos with an aim to promote and
                popularize Indian culture and heritage. Towards this, we propose
                creation of digital content to enable gamification based on
                Indian ethos to facilitate development of various games and
                virtual environments catering assets/ environments for learning,
                social awareness, therapeutics, leisure, and recreation. The
                assets and the framework of creating the assets can be extended
                to multiple scenarios and used for gamification/ virtualization.
              </ReadMore>
            </div>
          </div>
          <div className="row">
            <div className="col col-md text-center">
              <img src={kalpit} className="img-fluid" alt="KALPIT" />
            </div>
          </div>
          <br />
          <br />
          <div className="row">
            <div className="container">
              <div>
                <span className="sub-heading-font-size text-black">
                  Block Diagram for website:
                </span>
                <ol
                  className="list-number-size mt-2 mb-4"
                  style={{ lineHeight: "135%" }}
                >
                  <li className="content-font-size">
                    Creation of Characters: Rendering of the Key characters and
                    NPC along with the interaction with the user and AI
                    respectively. Users have the access to select the character
                    from the Indian Ethos (depending on the theme of the game).
                  </li>
                  <li className="content-font-size">
                    Creation of Environments: Rendering of the environment where
                    the scene generation varies from individual Key characters
                    selected by the user and can be generated using AI tools.
                  </li>
                  <li className="content-font-size">
                    Creation of Story: Story for the game comprises two things.
                    <ol style={{ listStyle: "lower-roman" }}>
                      <li>
                        Key Character Story: the story line from the perspective
                        of Key character from the birth till end depending on
                        the Indian Ethos. These key characters are joined to the
                        main story line.
                      </li>
                      <li>
                        Main Story Line: here all the individual characters
                        consolidate to one main frame depending on the Indian
                        Ethos.
                      </li>
                    </ol>
                  </li>
                </ol>
              </div>
              <div>
                <span className="sub-heading-font-size text-black">
                  {" "}
                  Towards Creation of Characters (PCs and NPCs), we have:
                </span>
                <ol
                  className="list-number-size mt-2 mb-4"
                  style={{ lineHeight: "135%" }}
                >
                  <li className="content-font-size">
                    Scanned human avatar assets comprising of full-body models,
                    hand models, and face models
                  </li>
                  <li className="content-font-size">
                    Developed a framework for generating 3D avatar and
                    accessories assets from a single image and also developed a
                    tool for generating 3D assets
                  </li>
                  <li className="content-font-size">
                    Creation of Story: Story for the game comprises two things.
                  </li>
                  <li className="content-font-size">
                    Towards customization of avatars we have:
                    <ol style={{ listStyle: "lower-roman" }}>
                      <li>
                        Proposed a framework for generating variations in 3D
                        garment models
                      </li>
                      <li>
                        Cloth draping framework to drape clothing accessories on
                        SMPL models
                      </li>
                      <li>Rigged accessories onto cloth draped avatar</li>
                    </ol>
                  </li>
                  <li className="content-font-size">
                    Towards animation of created avatar, we have:
                    <ol style={{ listStyle: "lower-roman" }}>
                      <li>
                        Rigged human avatars using tools like Blender to create
                        motions
                      </li>
                      <li>
                        Implemented transformer-based pose prediction model to
                        re-target human motion on SMPL model
                      </li>
                      <li>
                        Proposed animation methods considering physics
                        constraints of scene and the avatar to eliminate
                        foot-ground interaction artifacts and self-penetration
                        of the character
                      </li>
                      <li>
                        Proposed 4D point cloud refinement framework to
                        pre-processes Motion Capture (MoCap) data.{" "}
                      </li>
                    </ol>
                  </li>
                </ol>
              </div>
              <div>
                <span className="sub-heading-font-size text-black">
                  {" "}
                  Towards Creation of Environments, we have:
                </span>
                <ol
                  className="list-number-size mt-2 mb-4"
                  style={{ lineHeight: "135%" }}
                >
                  <li className="content-font-size">
                    Developed a framework for generating 3D environment assets
                    like temple pillars, scene elements, etc., from a multi-view
                    images and also developed a tool for generating 3D assets.
                  </li>
                </ol>
              </div>
              <div>
                <span className="sub-heading-font-size text-black">
                  {" "}
                  Towards Creation of Story, we have:
                </span>
                <ol
                  className="list-number-size mt-2 mb-4"
                  style={{ lineHeight: "135%" }}
                >
                  <li className="content-font-size">
                    Collaborated with Fashion and Apparel Design Department,
                    KLETech., to comprehend the evolution of clothing from
                    ancient era to modern day styles.
                  </li>
                  <li className="content-font-size">
                    Modeled clothing styles of Indus Valley Civilization and
                    Vedic Era
                  </li>
                  <li className="content-font-size">
                    Collaborated with School of Architecture, KLETech., to
                    develop a story line based on the history and evolution of
                    ancient temple architecture.
                  </li>
                </ol>
              </div>
              <div className="content-font-size">
                Click <Link to="/projects/sponsored/kalpit/assets">here</Link>{" "}
                to view a sample of the KALPIT assets.
              </div>
            </div>
          </div>
          {/* <div className="row">
              <div className="col-md-6">
                  <p>
                      
                  </p>
              </div>
              <div className="col-md-6">
                  <img src={img2} className="img-fluid" alt="Your Image"/>
              </div>
            
          </div> */}
        </div>
        {/* related publications code */}
        <br />
        <div className="text-center heading-font-size my-4 fw-bold">
          Related Publications
        </div>
        <PublicationsFetch projectFilter="KALPIT" />
        {/* related publications code */}
        <Footer />
      </div>
    </>
  );
}

export default KALPIT;
